<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses" v-if="$store.state.dash.allEntitiesLoaded || this.$route.meta.authRequired === false || this.$route.name === 'setup'">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import {
  auth
} from './firebase/firebaseConfig.js'

export default {
  data () {
    return {
      vueAppClasses: []
    }
  },
  computed: {
    isTrial () {
      return this.$store.getters['dash/subscription'].isTrialEnded
    }    
  },
  watch: {
    '$store.state.dash.logoURL' (v) {
      if (v) {
        //noconsoleconsole.log('LOGO URL CHANGED')
        let brandLogo = v
        let brandHex = this.$store.state.dash.brandHex
        if (!brandHex) return
          //noconsoleconsole.log(brandHex)
          //noconsoleconsole.log(brandLogo)
          this.$vs.theme({ primary: brandHex })
          /* No support if branded
          window.Beacon('config', {
            color: brandHex
          })*/
          document.body.classList.add('pt_grayimages')
      }
    },
    isTrial (v) {
      if (v === true) {
        if (this.$route.name === 'settings-plan' || this.$route.name === 'settings-plan-subscribe') {
        } else {
          this.$router.push('/dash/settings/plan')
        }
      }
    },
    /* Datashake review-import toasts + auto-refresh DISABLED — Chrome extension replaces Datashake. Whole per-platform watchers (ca/fs/fb/gp/ta/tp/ye) commented out for quick rollback; uncomment this block to restore.
    '$store.state.dash.viewData.business.externalPlatforms.ca': {
      handler: function(newV, oldV){
      if (newV !== false) {      
        if (newV.error && !oldV.error) {
          this.$vs.notify({
            title: 'Capterra reviews',
            text: 'There was an error importing your Capterra reviews - ensure that your profile address is correct, or reach out to support.',
            color: 'warning',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        } else if (oldV.last_successful_crawl !== newV.last_successful_crawl && newV.last_successful_crawl && oldV.last_successful_crawl) {
          
          this.$store.dispatch('dash/LOAD_REVIEWS', { platform: 'ca', reset: true })
          
          this.$vs.notify({
            title: 'Capterra reviews',
            text: 'Your Capterra reviews have been updated! See them under "View" > "Capterra".',
            color: 'success',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-check'})
        }      
      }
      },
      deep: true
    },
    '$store.state.dash.viewData.business.externalPlatforms.fs': {
      handler: function(newV, oldV) {
      
        

        if (newV !== false) {
        if (newV.error && !oldV.error) {
          this.$vs.notify({
            title: 'Foursquare reviews',
            text: 'There was an error importing your Foursquare reviews - ensure that your profile address is correct, or reach out to support.',
            color: 'warning',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        } else if (oldV.last_successful_crawl !== newV.last_successful_crawl && newV.last_successful_crawl && oldV.last_successful_crawl) {
          
          this.$store.dispatch('dash/LOAD_REVIEWS', { platform: 'fs', reset: true })
          
          this.$vs.notify({
            title: 'Foursquare reviews',
            text: 'Your Foursquare reviews have been updated! See them under "View" > "Foursquare".',
            color: 'success',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-check'})
        }     
      }
      },
      deep: true
    },
    '$store.state.dash.viewData.business.externalPlatforms.fb': {
      handler: function(newV, oldV) {
      if (newV !== false) {
        if (newV.error && !oldV.error) {
          this.$vs.notify({
            title: 'Facebook reviews',
            text: 'There was an error importing your Facebook reviews - ensure that your profile address is correct, or reach out to support.',
            color: 'warning',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        } else if (oldV.last_successful_crawl !== newV.last_successful_crawl && newV.last_successful_crawl && oldV.last_successful_crawl) {
          
          this.$store.dispatch('dash/LOAD_REVIEWS', { platform: 'fb', reset: true })

          this.$vs.notify({
            title: 'Facebook reviews',
            text: 'Your Facebook reviews have been updated! See them under "View" > "Facebook".',
            color: 'success',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-check'})
        }
      }
    },
      deep: true
    },
    '$store.state.dash.viewData.business.externalPlatforms.gp': {
      handler: function(newV, oldV) {
      console.log(`gp changed`)
      console.log(newV)
      
      if (newV !== false) {
        
        if (newV.error && !oldV.error) {
          this.$vs.notify({
            title: 'Google reviews',
            text: 'There was an error importing your Google reviews - ensure that your profile address is correct, or reach out to support.',
            color: 'warning',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        } else if (oldV.last_successful_crawl !== newV.last_successful_crawl && newV.last_successful_crawl && oldV.last_successful_crawl) {
          
          this.$store.dispatch('dash/LOAD_REVIEWS', { platform: 'gp', reset: true })
          
          this.$vs.notify({
            title: 'Google reviews',
            text: 'Your Google reviews have been updated! See them under "View" > "Google".',
            color: 'success',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-check'})
        }

      }

      },
      deep: true
    },
    '$store.state.dash.viewData.business.externalPlatforms.ta': {
      handler: (newV, oldV) => {
      if (newV !== false) {
        if (newV.error && !oldV.error) {
          this.$vs.notify({
            title: 'Tripadvisor reviews',
            text: 'There was an error importing your Tripadvisor reviews - ensure that your profile address is correct, or reach out to support.',
            color: 'warning',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        } else if (oldV.last_successful_crawl !== newV.last_successful_crawl && newV.last_successful_crawl && oldV.last_successful_crawl) {
          
          this.$store.dispatch('dash/LOAD_REVIEWS', { platform: 'ta', reset: true })

          this.$vs.notify({
            title: 'Tripadvisor reviews',
            text: 'Your Tripadvisor reviews have been updated! See them under "View" > "Tripadvisor".',
            color: 'success',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-check'})
        }    
      }
    },
      deep: true
    },
    '$store.state.dash.viewData.business.externalPlatforms.tp': {
      handler: (newV, oldV) => {
      if (newV !== false) {
        if (newV.error && !oldV.error) {
          this.$vs.notify({
            title: 'Trustpilot reviews',
            text: 'There was an error importing your Trustpilot reviews - ensure that your profile address is correct, or reach out to support.',
            color: 'warning',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        } else if (oldV.last_successful_crawl !== newV.last_successful_crawl && newV.last_successful_crawl && oldV.last_successful_crawl) {
          
          this.$store.dispatch('dash/LOAD_REVIEWS', { platform: 'tp', reset: true })
          
          this.$vs.notify({
            title: 'Trustpilot reviews',
            text: 'Your Trustpilot reviews have been updated! See them under "View" > "Trustpilot".',
            color: 'success',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-check'})
        }       
      }
    },
      deep: true
    },
    '$store.state.dash.viewData.business.externalPlatforms.ye': {
      handler: (newV, oldV) => {
      if (newV !== false) {
        if (newV.error && !oldV.error) {
          this.$vs.notify({
            title: 'Yelp reviews',
            text: 'There was an error importing your Yelp reviews - ensure that your profile address is correct, or reach out to support.',
            color: 'warning',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        } else if (oldV.last_successful_crawl !== newV.last_successful_crawl && newV.last_successful_crawl && oldV.last_successful_crawl) {
          
          this.$store.dispatch('dash/LOAD_REVIEWS', { platform: 'ye', reset: true })

          this.$vs.notify({
            title: 'Yelp reviews',
            text: 'Your Yelp reviews have been updated! See them under "View" > "Yelp".',
            color: 'success',
            time: 13000,
            iconPack: 'feather',
            icon:'icon-check'})
          }      
        }
      },
      deep: true
    },
    */
    '$store.state.dash.allEntitiesLoaded' () {
      const appLoading = document.getElementById('loading-bg')
      if (appLoading) {
      appLoading.style.display = 'none'
      }
    },
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    signOut () {

      this.$store.dispatch('auth/logout').then(() => {
        //the main.js code will catch auth state change
      }).catch(() => {})

    },
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted () {


    console.log('main app mounted')
    console.log(this.$store.state.dash.viewData.business)

    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)

  },
  created () {

    window.logoutFBLUser = this.signOut

    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    const brandHex = this.$store.state.dash.brandHex
    const logoURL = this.$store.state.dash.logoURL

    //set branding if neccesary
    if (brandHex && logoURL) {      
      this.$vs.theme({ primary: brandHex })
      
      /*
      No support if branded
      window.Beacon('config', {
        color: brandHex
      })*/

      document.body.classList.add('pt_grayimages')
    }

    //PIET ADDITIONS

    //Here we register the current user into the store, but only
    //if we're not in setup because the setup component does so already
    if (this.$route.name !== 'setup' ) {
      let user = auth.currentUser
      if (user) {
        let token = user.getIdToken(true).then((token) => {
            this.$store.commit('auth/SET_CURRENT_USER', {...user, token})
        })
      }    
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>
